"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Collapse: function() {
        return Collapse;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Collapse = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M3.15429 21.4924H20.5414C22.641 21.4924 23.6957 20.448 23.6957 18.3789V6.11357C23.6957 4.04443 22.641 3 20.5414 3H3.15429C1.065 3.00043 0 4.035 0 6.11357V18.3793C0 20.4583 1.065 21.4924 3.15429 21.4924ZM3.18429 19.8759C2.17971 19.8759 1.61743 19.3436 1.61743 18.2987V6.195C1.61743 5.15014 2.17971 4.61786 3.18429 4.61786H7.65429V19.8759H3.18429ZM20.5114 4.61786C21.5057 4.61786 22.0783 5.15014 22.0783 6.195V18.2979C22.0783 19.3427 21.5057 19.875 20.5114 19.875H9.23143V4.61743L20.5114 4.61786ZM5.72571 8.34471C6.027 8.34471 6.29829 8.07343 6.29829 7.782C6.29829 7.48071 6.027 7.21971 5.72571 7.21971H3.56571C3.26486 7.21971 3.00343 7.48071 3.00343 7.782C3.00343 8.07343 3.26486 8.34471 3.56614 8.34471H5.72571ZM5.72571 10.9461C6.027 10.9461 6.29829 10.6749 6.29829 10.3736C6.29829 10.0723 6.027 9.82071 5.72571 9.82071H3.56571C3.26486 9.82071 3.00343 10.0723 3.00343 10.3736C3.00343 10.6749 3.26486 10.9461 3.56614 10.9461H5.72571ZM5.72571 13.5377C6.027 13.5377 6.29829 13.2866 6.29829 12.9849C6.29829 12.684 6.027 12.4226 5.72571 12.4226H3.56571C3.26486 12.4226 3.00343 12.684 3.00343 12.9853C3.00343 13.2866 3.26486 13.5377 3.56614 13.5377H5.72571Z",
        fill: "currentColor"
    })
}), "Collapse");
const _default = Collapse;
